<template>
  <client-only>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="330"
        content-class="leaveDialog"
        persistent
      >
        <v-card id="leaveP" class="mx-auto text-center pt-4 pb-4" outlined>
          <div class="text-center avatar-box">
           <img src="~/assets/23/avatar.svg" class="avatar-agent" width="38%"/>
          </div>

          <v-card-text class="text--primary py-0">
            <!-- <div class="text-center display-16 pb-1">רגע לפני שעוזבים ,</div> -->
            <p class="display-18 text-center font-weight-medium">
              למה אתם עוזבים כל כך מהר?  <br/> תנסו אותי...
            </p>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              class="mx-auto text-center"
              rounded
              @click="stay()"
            >
              מעוניין להמשיך ברישום
            </v-btn>
          </v-card-actions>
          <v-card-actions class="pt-0">
            <v-btn
              color="primary"
              class="mx-auto text-center"
              text
              x-large
              max-height="20"
              @click="leave()"
            >
              אולי בפעם אחרת
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </client-only>
</template>

<script>
import gtm from '@/lib/gtm';
export default {
  data() {
    return {
      dialog: false,
      resolve: null,
    };
  },

  methods: {
    pop() {
      this.dialog = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    stay() {
      this.dialog = false;
      gtm({
        action: 'מעוניין להמשך ברישום',
        category: 'smart agent popup',
        event: 'smart agent popup',
      });
      this.resolve(false);
    },
    leave() {
      this.dialog = false;
      gtm({
        action: 'אולי בפעם אחרת',
        category: 'smart agent popup',
        event: 'smart agent popup',
      });
      this.resolve(true);
    },
  },
};
</script>


<style lang="scss" scoped>
#leaveP.v-sheet.v-card {
  border-radius: 30px;
  border: 1px solid $primary;
}

.icon {
  font-size: 70px;
}
.avatar-box{
  display: flex;
  justify-content: center;
}
@media only screen and (min-width: 600px) {
  .ico {
    font-size: 50px;
  }
}
</style>
